<div class="kam-contact-info-component">
  <div class="title">{{ 'module.contact.personalAccountManagerGreetingsText' | translate }}</div>
  <div class="details">
    <div class="kam-image">
      <span *ngIf="imageSrc === ''" class="fa fa-user-circle"></span>
      <img *ngIf="imageSrc" class="kam-pic" [src]="imageSrc" alt="your image" />
      <div class="imageLoading" *ngIf="isImageLoading">
        <span class="fa fa-spinner fa-spin fa-3x"></span>
      </div>
    </div>
    <div class="kam-contact-info">
      <div class="name">{{ kamUser.firstName }} {{ kamUser.lastName }}</div>
      <div class="department">{{ 'module.contact.contactDepartment' | translate }}</div>
      <div class="company">{{ kamUser.company }}</div>
      <div *ngIf="kamUser.textT">
        <span class="label">T:</span>
        <span class="number" (click)="dialer(kamUser.textT)">{{ kamUser.textT }}</span>
      </div>
      <div *ngIf="kamUser.mobile">
        <span class="label">M:</span>
        <span class="number" (click)="dialer(kamUser.mobile)">{{ kamUser.mobile }}</span>
      </div>
      <div *ngIf="kamUser.textF">
        <span class="label">Fax:</span>
        <span class="number" (click)="dialer(kamUser.textF)">{{ kamUser.textF }}</span>
      </div>
      <div class="email" *ngIf="kamUser.email">
        <div class="label email-label">E-Mail:</div>
        <div class="contact-email" (click)="mailer()">{{ kamUser.email }}</div>
      </div>
    </div>
  </div>
</div>
